import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ELandingType } from '../../types/landingType';

interface IPayload {
  landingType: ELandingType;
}

// @TODO логирование ошибки если анекспектед прорастет до компонентов
const initialState: ELandingType = ELandingType.Unexpected as ELandingType;

const landingTypeSlice = createSlice({
  name: 'landingType',
  initialState,
  reducers: {
    setLandingType: (_state, action: PayloadAction<IPayload>) => action.payload.landingType,
  },
});

export const {
  reducer: landingTypeReducer,
  actions: { setLandingType },
} = landingTypeSlice;
